"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendChannelsRequests = exports.ImportantChannels = void 0;
const Paths_1 = require("../Paths");
const Utils_1 = require("../Utils");
const OptionsHandler_1 = require("./IndexUtils/OptionsHandler");
var ImportantChannels;
(function (ImportantChannels) {
    ImportantChannels["PROD"] = "prod";
    ImportantChannels["DOGFOOD"] = "dogfood";
    ImportantChannels["BETA"] = "beta";
    ImportantChannels["NOOP"] = "noop";
})(ImportantChannels = exports.ImportantChannels || (exports.ImportantChannels = {}));
class BackendChannelsRequests {
    constructor(session, appInfo) {
        this.session = session;
        this.appInfo = appInfo;
        this.options = new OptionsHandler_1.OptionsHandler(this.appInfo);
    }
    getChannels(protectedChannels) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint({ queryParam: protectedChannels !== undefined ? `protected=${protectedChannels}` : "" });
            return this.makeRequest(endpoint, options);
        });
    }
    getChannelByName(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.GET,
            };
            const endpoint = this.getRootEventEndpoint({ name });
            return this.makeRequest(endpoint, options);
        });
    }
    addChannel(channel) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: channel,
            };
            const endpoint = this.getRootEventEndpoint();
            return this.makeRequest(endpoint, options);
        });
    }
    editChannel(name, args) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.POST,
                body: {
                    fwVersion: args.fwVersion,
                    manifestUrl: args.manifestUrl,
                    protected: args.protected,
                },
            };
            const endpoint = this.getRootEventEndpoint({ name });
            return this.makeRequest(endpoint, options);
        });
    }
    deleteChannel(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                method: Paths_1.Methods.DELETE,
            };
            const endpoint = this.getRootEventEndpoint({ name });
            return this.makeRequest(endpoint, options);
        });
    }
    makeRequest(endpoint, options) {
        return __awaiter(this, void 0, void 0, function* () {
            const request = yield (0, Utils_1.buildGenericRequest)(this.session, options, this.options);
            return (0, Utils_1.wrapFetchJson)(request, endpoint);
        });
    }
    getRootEventEndpoint(opts) {
        let name;
        let queryParam;
        if (opts !== undefined) {
            name = opts.name;
            queryParam = opts.queryParam;
        }
        return `${this.session.baseUrl}/${Paths_1.Constants.V1_CHANNELS}${name ? `/${name}` : ""}${queryParam ? `?${queryParam}` : ""}`;
    }
}
exports.BackendChannelsRequests = BackendChannelsRequests;
//# sourceMappingURL=BackendChannels.js.map